module.exports = "<div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><h1>Benvenuto in POS-PiMUS</h1></div></div></div>"